import { ICON__eye_slash_solid, ICON__eye_solid } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { UTILS__graph_data } from '@/utils/UTILS__graph_data';
import { assert_array_not_empty, assert_instanceof } from '@shared/asserts/utils_asserts';
import { FIELD_PRIMITIVE__base_string } from '@shared/dto/generation/graph_invoke/_fields/_primitives/string/FIELD_PRIMITIVE__base_string';
import { delete_value_from_array } from '@shared/utils/utils_array';
import { useTranslation } from 'react-i18next';

interface PROPS {
  field: FIELD_PRIMITIVE__base_string;
}

export function G_BUTTON__field_string_list_item_change_visibility({ field }: PROPS) {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SEARCH);

  const { generation_current } = use_slice_generation(['generation_current']);
  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);

  let is_used = field.get_value_range().includes(field.get_value());

  async function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    let field_from_graph = generation_current.tool.graph.field__get_by_id(field.meta.field_id);
    assert_instanceof(field_from_graph, FIELD_PRIMITIVE__base_string);

    let field_new = field_from_graph.clone();

    if (is_used) {
      let values_range = field_new.get_value_range();

      delete_value_from_array(values_range, field.get_value());

      assert_array_not_empty(values_range);

      let value_new = values_range[0];

      field_new.set_value(value_new);

      field_new.set_value_range(values_range);
    } else {
      field_new.add_value_to_values_range(field.get_value());
    }

    await UTILS__graph_data.update_field(generation_current.tool.graph, field_new);
  }

  function is_disabled() {
    return field.meta.ui__is_readonly || g_general__ui_disabled;
  }

  if (field.get_value_range().length <= 1) return null; //can't hide last value
  if (field.meta.kind__is_output) return null;
  if (field.meta.data__is_linked) return null;

  return (
    <UI_PRIMITIVE__button_with_icon_animated
      size="3-full"
      variant="no-border-on-bar"
      iconClassNameBase="!text-component-item-foreground size-3"
      iconClassNameHovered="!text-bar-foreground"
      {...{ onClick }}
      disabled={is_disabled()}
      renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
      Icon={is_used ? ICON__eye_solid : ICON__eye_slash_solid}
    />
  );
}
